import React from 'react';
import {useEnvironment, useExperiments} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../Widget/ControllerContext';
import {TPAComponentsProvider} from '@wix/wix-ui-tpa/cssVars';
import {getDirValue} from '../../../domain/utils/getDirValue';
import {pageTheme} from '../../../common/components/WithThemeOverride/pageTheme';
import {LoadingLayout} from './LoadingLayout';
import {LoadedLayoutLazy} from './LoadedLayoutLazy';
import {SPECS} from '../../../common/constants';

const CheckoutApp = () => {
  const {failedToFetch, isLoading, isOneColumnView, checkoutSettingsStore, navigationStore} = useControllerProps();
  const {isRTL, isMobile} = useEnvironment();
  const {experiments} = useExperiments();

  const hasNoPremium = !isLoading && !checkoutSettingsStore?.isPremium;
  const hasOldPremiumError =
    !experiments.enabled(SPECS.HandleCheckoutErrorStates) && hasNoPremium && !navigationStore?.isOwnerOrPreview;
  const hasError = failedToFetch || hasOldPremiumError;

  const loadingLayout = <LoadingLayout isOneColumnView={isOneColumnView} />;

  return (
    <div style={pageTheme} className={isMobile ? 'mobile-view' : undefined}>
      <TPAComponentsProvider value={{rtl: isRTL}}>
        {isLoading && !hasError ? (
          loadingLayout
        ) : (
          <LoadedLayoutLazy
            fallback={loadingLayout}
            dir={getDirValue(isRTL)}
            showErrorState={hasError}
            hasPremiumError={hasOldPremiumError}
            loaded={!isLoading}
          />
        )}
      </TPAComponentsProvider>
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default CheckoutApp;
